import { render, staticRenderFns } from "./apiCertiList.vue?vue&type=template&id=6ef4cce7&scoped=true&"
import script from "./apiCertiList.vue?vue&type=script&lang=js&"
export * from "./apiCertiList.vue?vue&type=script&lang=js&"
import style0 from "./apiCertiList.vue?vue&type=style&index=0&id=6ef4cce7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef4cce7",
  null
  
)

export default component.exports